export const formatOrderPrice = price => (
  price === '0.00' ? 'FREE' : `£${price}`
)
